import styled from 'styled-components'

export type ChipTone = 'success' | 'danger' | 'info' | 'warning' | 'neutral'

// Shared status/confidence pill for the admin pages. Colors come from the
// Odyssey ticket-status palette so chips read consistently everywhere.
const StatusChip = styled.span<{ $tone: ChipTone }>`
  display: inline-block;
  padding: 3px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: capitalize;
  white-space: nowrap;
  background-color: ${(props) => {
    switch (props.$tone) {
      case 'success':
        return props.theme.customPalette.ticketStatusResolved.backgroundColor
      case 'danger':
        return props.theme.customPalette.ticketStatusClosed.backgroundColor
      case 'info':
        return props.theme.customPalette.ticketStatusOpen.backgroundColor
      case 'warning':
        return '#fff3e0'
      default:
        return props.theme.customPalette.background.statusChip
    }
  }};
  color: ${(props) => {
    switch (props.$tone) {
      case 'success':
        return props.theme.customPalette.ticketStatusResolved.color
      case 'danger':
        return props.theme.customPalette.ticketStatusClosed.color
      case 'info':
        return props.theme.customPalette.ticketStatusOpen.color
      case 'warning':
        return props.theme.customPalette.archiveOrange
      default:
        return props.theme.palette.primary.main
    }
  }};
`

export default StatusChip
